export enum TimelineSurveyResponsesKnowledgeableAnswers
{
    Less = 0,
    Same = 1,
    More = 2
}

export class TimelineSurveyResponses
{
    // How likely are you to recommend this product to a fellow student or professor?
    // 0-10 with 10 being most likely
    howLikelyToRecommend: number | null = null;

    // After completing a timeline in ClioVis, how knowledgeable/confident in your topic do you feel?
    howKnowledgeableOrConfident: TimelineSurveyResponsesKnowledgeableAnswers | null = null;

    // What can we do to make the ClioVis experience better?
    howToImprove: string | null = ''
}